import { render, staticRenderFns } from "./Associations.vue?vue&type=template&id=41500a5e&scoped=true"
import script from "./Associations.vue?vue&type=script&lang=js"
export * from "./Associations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41500a5e",
  null
  
)

export default component.exports